import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workProjectTypeGrid: [],
    workProjectTypeAll: [],
    workProjectTypeAllSegment: [],
    workProjectTypeShow: null,
    pageData: null,
  },
  mutations: {
    setWorkProjectTypeGrid(state, payload) {
      state.workProjectTypeGrid = payload
    },
    setWorkProjectTypeAll(state, payload) {
      state.workProjectTypeAll = payload
    },
    setWorkProjectTypeAllSegment(state, payload) {
      state.workProjectTypeAllSegment = payload
    },
    setWorkProjectTypeShow(state, payload) {
      state.workProjectTypeShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workProjectTypeGrid: (state) => {
      return state.workProjectTypeGrid
    },
    workProjectTypeAll: (state) => {
      return state.workProjectTypeAll
    },
    workProjectTypeAllSegment: (state) => {
      return state.workProjectTypeAllSegment
    },
    workProjectTypeShow: (state) => {
      return state.workProjectTypeShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkProjectTypeGrid({ commit, rootState }, { limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain + '/api/admin/work/project-type/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkProjectTypeGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkProjectTypeAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain + '/api/admin/work/project-type/grid?limit=0' + '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkProjectTypeAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkProjectTypeAllSegment({ commit, rootState }, segmentId) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/project-type/grid?limit=0&order[]=name:asc&filter[]=business_segments_id:' +
            segmentId,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkProjectTypeAllSegment', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkProjectTypeShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-type/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkProjectTypeShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkProjectTypeCreate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-type',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', {
              message: rootState.translations.notifications['uspeshno-dobavlen'],
              IsError: false
            }, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkProjectTypeUpdate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-type',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
            dispatch('popup/onMessage', { IsError: false }, {root: true})
          })
          .catch((err) => {
            reject(err)
            dispatch('popup/onMessage', {IsError: true}, {root: true})
          })
      })
    },
    onWorkProjectTypeDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/project-type/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
